export const ROUTES = {
  HOME: {
    CAPTION: "Home",
    TO: "/",
  }
};